<template>
  <div class="Index">
    <el-row :gutter="24" style="margin:0;">
      <el-col :span="6" :offset="4"  >
         <div class="Index-head-img">
          <img src="../assets/img/1.1.png" alt="">
         </div>
      </el-col>
      <el-col :span="9">
        <div class="Index-head-text">
          <p>COMPANY PROFILE</p>
          <P>十方星链（苏州）航天科技有限公司</P>
          <p style="line-height:28px;">十方星链（苏州）航天科技有限公司成立于2022年11月，是国家国防科技先进技术成果转化重点支持的商业航天企业。</p>
          <p style="line-height:28px;">公司以建设运营我国第一个中轨道（MEO）中继卫星系统为目标，以天地一体化航天测运控与数据中继业务为主导，为各类运载器（如火箭、导弹）、航天器（如卫星、飞船）、航空器（如飞机、无人机）、临近空间飞行器（如飞艇）、舰船及海外站点等陆海空天电各类平台提供高覆盖、强实时、高速率的测控及数传服务，致力于成为我国商业航天天基测控与空间信息传输领域引领者。
</p>


         </div>
      </el-col>
    </el-row>
    <el-row :gutter="0" style="margin:0;">
      <el-col :span="20" :offset="4" >
    <div class="Index-head-strip">
      <span class='Index-head-span' > <b @click="imgClick(1)">发展历程</b>  <img @click="imgClick(1)" src="../assets/img/1.2.png" alt="" srcset=""></span>
      <span class='Index-head-span' > <b @click="imgClick(2)">荣誉资质</b>   <img @click="imgClick(2)" src="../assets/img/1.2.png"  alt="" srcset=""></span>
    </div>
  </el-col>
    </el-row>
    <p class="Index-head-p">
      PRODUCTS
      <b>产品服务</b>
    </p>

    <el-row :gutter="20" style="margin:0;">
      <el-col :span="9" :offset="4">
        <div class="product-head">
            <img src="../assets/img/1.3.png" id="imgind1" alt="" srcset="">
            <p>
              <span>昆仑·中继卫星星座</span>
              <span>Kunlun Relay Satelite Constellation</span>
              <span style="cursor:pointer" @click="clickspan(1)">了解更多</span>
            </p>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="product-head">
            <img src="../assets/img/1.4.png" alt="" srcset="">
            <p>
              <span>天柱·地面终端站网</span>
              <span>Tianzhu Ground Terminal Website</span>
              <span style="cursor:pointer" @click="clickspan(2)">了解更多</span>
            </p>
        </div></el-col>
    </el-row>
    <el-row :gutter="20" style="margin:0;">
      <el-col :span="5" :offset="4">
        <div class="product-head">
            <img src="../assets/img/1.5.png" alt="" srcset="">
            <p>
              <span>龙行·测运控系统</span>
              <span>LongXing Tracking Telemetry Control System</span>
              <span style="cursor:pointer" @click="clickspan(3)">了解更多</span>
            </p>
        </div></el-col>
      <el-col :span="5">
         <div class="product-head">
            <img src="../assets/img/1.6.png"  alt="" srcset="">
            <p>
              <span>航天技术服务</span>
              <span>Space Tech Knowledge Transfer Services</span>
              <span style="cursor:pointer" @click="clickspan(4)">了解更多</span>
            </p>
        </div></el-col>
        <el-col :span="5">
         <div class="product-head">
            <img src="../assets/img/1.71.png" id="imgind2" alt="" srcset="">
            <p>
              <span>航天教育科普</span>
              <span>Space Science Education and Public Outreach</span>
              <span style="cursor:pointer" @click="clickspan(4)">了解更多</span>
            </p>
        </div></el-col>
    </el-row>

    <p class="Index-head-p">
      NEWS
      <b>新闻动态</b>
    </p>

    <el-row :gutter="24" style="margin:0;">
      <el-col :span="7" :offset="4">
        <div class="news-head">
          <img :src='imgsclick' alt="">
        </div>
      </el-col>
      <el-col :span="8" >
        <div class="news-text" v-if="newslist.length>0">
          <li  v-for="(item,index) in newslist" :key="index" :class="item.id==clickId?'checkclick':''"  @mouseover="newclick(item,1)" >
            <div class="triangle-down" v-if="item.id==clickId"></div>
            <b>{{item.title}}</b>
            <p class="two">{{item.text}}</p>
            <p><span>{{item.time}}</span> <b></b> <span style="cursor: pointer;" @click="spansclick(item)">MORE <i class="el-icon-caret-right"></i></span></p>
          </li>
        </div>
      </el-col>

    </el-row>

    <p class="Index-head-p">
      CUSTOMER
      <b>合作伙伴</b>
    </p>
    <el-row>
      <el-col :span="15" :offset="4">
        <img class="customer-img"  src="../assets/img/110.png" alt="" srcset="">
      </el-col>
    </el-row>
    <!-- <el-row :gutter="0" style="margin:0;">
      <el-col :span="3" :offset="4" >
        <img class="customer-img"  src="../assets/img/1.12.png" alt="" srcset="">
      </el-col>
      <el-col :span="3" >
        <img class="customer-img"  src="../assets/img/1.9.png" alt="" srcset="">
      </el-col>
      <el-col :span="3" >
        <img class="customer-img"  src="../assets/img/1.10.png" alt="" srcset="">
      </el-col>
      <el-col :span="3" >
        <img class="customer-img"  src="../assets/img/1.11.png" alt="" srcset="">
      </el-col>
      <el-col :span="2" >
        <img class="customer-img"  src="../assets/img/1.8.png" alt="" srcset="">
      </el-col>
      <el-col :span="2">
        <img class="customer-img"  src="../assets/img/1.15.png" alt="" srcset="">
      </el-col>


    </el-row>

    <el-row :gutter="0" style="margin:0;">
      <el-col :span="10" :offset="4" >
        <img class="customer-img" src="../assets/img/1.13.png" alt="" srcset="">
      </el-col>
      <el-col :span="6" >
        <img class="customer-img" src="../assets/img/1.14.png" alt="" srcset="">
      </el-col>
    </el-row> -->

  </div>
</template>

<script>
import lxapi from '../api/api';
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
    newslist:[],
    clickId:0,
    imgsclick:'',

    };
  },
  mounted() {
    this.show2 = true;
    this.getlist()
  },
  methods: {
    getlist(){
      var data=`?homePage=1&pageSize=3`
      lxapi.getlist(data).then(res=>{
      this.newslist=res.rows
      this.imgsclick=this.newslist[0].thumbnail
      this.clickId=this.newslist[0].id
    }).catch(err=>{
      console.log(err)
    })
    },
    enter() {
      console.log("111");
      this.headerRigh = true;
    },
    leave() {
      this.headerRigh = false;
    },
    clickspan(index){
        this.$router.push({path:'/product',query:{id:index}})
  },
    spansclick(item){
      this.$router.push({path:'/new',query:{id:item.id}})
  },
  newclick(item){
    this.clickId=item.id
    this.imgsclick=item.thumbnail
  },
  imgClick(num){
    this.$router.push({path:'/about',query:{id:num}})

  },
},
created(){

},
}
</script>

<style scoped lang="scss">
.Index {
    .Index-head-img{
    img{
      width:100%;
      height:300px;
      border-radius: 0 50px 0 50px;
    }
  }
  .Index-head-text{
    p{
      font-size:16px;
      margin-top:10px;
      color:#6a6a6a;
    }
    p:nth-child(1){
      font-size:24px;
      color:#0152a1;
      white-space: nowrap;
      margin:0;
      font-weight:500;

    }
    p:nth-child(2){
      margin-top:0;
      font-size:24px;
      color:#0152a1;
      margin-bottom: 20px;
      white-space: nowrap;
      font-weight:500;
    }
    p:nth-child(3),p:nth-child(4){
      width:100%;
    }
  }

.Index-head-strip{
  margin-top:40px;
  background: url('../assets/img/2.png') no-repeat;
  height:70px;
  color:white;
  padding-left:35%;
  font-size:16px;
  background-size:100% 100%;
  position: relative;
  span:nth-child(2){
    position: absolute;
    left:60%;
    margin:0;
    top:25px;
    padding:0;
  }

  img{
    width:22px;
    height:22px;
    margin-left:10px;
    cursor: pointer;

  }
  span{
    padding-top:25px;
    height:20px;
    display: flex;
  }
  b{
    cursor: pointer;
  }
  b:hover+img{
    height:26px;
      width:26px;
      margin-top:-2px;
   }
  .Index-head-span img:hover{
      height:26px;
      width:26px;
      margin-top:-2px;
  }
}
.Index-head-p{
  text-align: center;
  font-size:100px;
  font-weight: 800;
  position: relative;
  color:#f1f5f8;
  margin-top:50px;
  b{
    position: absolute;
    left:50%;
    top:50%;
    font-size:26px;
    color:black;
    width:120px;
    height:50px;
    display: block;
    margin-left:-50px;
    margin-top:-25px;
    line-height:60px;
  }
}

.product-head{
  position: relative;
  height:300px;
  img{
    width:100%;
    height:270px;
  }
  p{
    position: absolute;
    top:30%;
    left:10%;
    color:white;
    font-size:22px;
    span{
      display: block;
    }
    span:nth-child(2){
      margin-bottom:10px;
    }
    span:nth-child(3){
      display: inline-block;;
      font-size:16px;
      padding:5px;
      border:1px solid white;
    }
  }

}
.product-head:hover{
  img{
    position: absolute;
    width:104%;
    margin-left:-2%;
    margin-top:-10px;
    height:300px;
  }
  p{
    font-size:24px;
    span:nth-child(3){
      font-size:18px;
    }
  }
    // box-shadow: 0 0 10px 10px#ccc
}
// .product-head:nth-child(1){
//   margin-bottom: 20px;
// }
#imgind1{
  border-radius: 76px 0 0 0;
}
#imgind2{
  border-radius: 0 0 62px 0;
}

.news-head{
  img{
    width:100%;
    height:440px;
    border-radius: 50px 0  50px 0 ;
  }
}
.news-text{
  li{
    cursor: pointer;
    position: relative;
  }
  .triangle-down {
    position:absolute;
    top:0;
    left:-20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 20px solid #0152a1;
}
  b{
    display: block;
    overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
    font-weight: 400;
    padding:0 0 10px 20px;
    font-size:22px;
  }
  li{
    height:120px;
    margin-bottom: 10px;
    padding:10px 0;
    box-shadow:0px 0px 5px 5px #ccc;
    background: #ffffff;
  p{
    padding:0 20px 0 20px;
    margin-top:10px;
    color:#c1c1c1;
    display: flex;
    span:nth-child(3){
     color:#0152a1;
     font-weight: 700;
    }
    b{
      flex:1;
    }
  }
  .two{
    width:90%;
    margin:0;
    display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  }
  }
  .checkclick{
    color:white;
    background: #0152a1;
    b{
      font-weight: 400;
    }
    p{
      color:white;
      span:nth-child(3){
      color:white;
      }
    }

  }
}
.customer-img{
  width:100%;
  // height:180px;
  // object-fit:fill;
  margin-bottom: 10px;
}

}
.bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
// 响应式
@media only screen and (max-width: 767px) {
.Index {
  padding-top:50px;
  .Index-head-text{
    p{
      padding-top:10px;
      font-size: 12px !important;
    }
    p:nth-child(2){
      padding-top:0;
    }
    p:nth-child(3){
      display: none;
    }
    p:nth-child(4){
      display: none;
    }
  }
  .Index-head-p{
    font-size: 46px;
    margin-top:0;
    b{
      font-size:16px;
    }
  }
  .Index-head-img{
    img{
      height:auto;
      border-radius:0;
    }
  }
  .product-head img{
   height:100px;
  }
  .product-head p{
  font-size:5px;
  span{
    font-size:5px !important;
  }
  }
  .customer-img{
  width:100%;
  height:50px;
  margin-bottom: 10px;
}
}
.news-text{
  display: none;
}
.news-head{
  display: none;
}

}
</style>
